import { render, staticRenderFns } from "./NavExerciseLargeSet.vue?vue&type=template&id=2d67b8f6"
import script from "./NavExerciseLargeSet.vue?vue&type=script&lang=js"
export * from "./NavExerciseLargeSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports